import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  CircularProgress,
  Box,
  Grid,
  Avatar,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import CardHistoryTable from "src/components/cards-table/CardHistoryTable";
import { get } from "src/utils/networkUtils";

export default function CardPage() {
  const [loading, setLoading] = useState(true);
  const [card, setCard] = useState(null);
  const [cardHistory, setCardHistory] = useState(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has("card_id")) {
      let cardId = searchParams.get("card_id");
      get(`/admin/cards/${cardId}`).then(function (response) {
        setCard(response.card);
        setLoading(false);
      });
      get(`/admin/cards/${cardId}/history`).then(function (response) {
        setCardHistory(response.history);
      });
    }
  }, [searchParams]);

  return (
    <>
      <Helmet>
        <title> Card </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Card Details
          </Typography>
        </Stack>

        <Card sx={{ p: 2 }}>
          {card === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3} sx={{ mb: 2 }}>
              <Grid item xs={4}>
                <Avatar
                  src={"/assets/images/avatars/avatar_2.jpg"}
                  alt="Card"
                  sx={{ width: 80, height: 80 }}
                />
              </Grid>
              <Grid item xs={8}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Typography variant="title" sx={{ fontWeight: "bold" }}>
                      {card.firstname} {card.lastname}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle">
                      {card.externalRef}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
          {cardHistory !== null && <CardHistoryTable history={cardHistory} />}
        </Card>
      </Container>
    </>
  );
}
